<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>Kullanıcı Düzenle <small>( {{ first_name }} {{ last_name }} )</small></h3>
            </div>
            <div class="row">

              <div class="col-md-6">
                <div class="form-group">
                  <label for="first_name">Ad</label>
                  <input
                    type="text"
                    v-model="first_name"
                    class="form-control custom-input"
                    placeholder
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="last_name">Soyad</label>
                  <input
                    type="text"
                    v-model="last_name"
                    class="form-control custom-input"
                    placeholder
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">E-posta</label>
                  <input type="text" v-model="email" class="form-control custom-input" autocomplete="off">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="password">Şifre <small>(Şifre değişikliği olmayacaksa boş bırakınız)</small></label>
                  <input
                    type="password"
                    v-model="password"
                    class="form-control custom-input"
                    autocomplete="off"
                  >
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <button class="btn btn-success pull-right" @click="updateData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      api: "panel_users/",
      id: this.$route.params.id,
      first_name: "",
      last_name: "",
      email: "",
      password: '',
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios.get(this.api + this.id + "/edit").then(response => {
        this.first_name = response.data.first_name;
        this.last_name = response.data.last_name;
        this.email = response.data.email;
      });
    },
    updateData() {
      this.$Progress.start()
      this.axios.put(this.api + this.id, {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        password: this.password,
      }).then(response => {
        if(response.status == 200) {
          this.$Progress.finish()
        }
      })
    }
  }
};
</script>

<style scoped>
</style>